import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryContainer from '../../components/ErrorBoundaryContainer';
import Loading from '../../components/Loading';

import accountRouter from '../account';

const HeatstrokeDashboardPage = lazy(
  () =>
    import(
      /* webpackChunkName: "heatstroke-dashboard-page" */ '../../pages/daswbgt-dashboard'
    ),
);

const heatstrokeDashboardRouter = (
  <Route path="daswbgt-dashboard">
    <Route
      path=":projectId"
      element={
        <Suspense fallback={<Loading />}>
          <ErrorBoundaryContainer
            key="daswbgt-dashboard"
            component={<HeatstrokeDashboardPage />}
          />
        </Suspense>
      }
    >
      {accountRouter()}
    </Route>
  </Route>
);

export default heatstrokeDashboardRouter;
